// extracted by mini-css-extract-plugin
export default {"yivi-web-form":"yivi_table_yivi-web-form__fvCy6","yivi-web-content":"yivi_table_yivi-web-content__hCh9z","table":"yivi_table_table__TJuYJ"};